// extracted by mini-css-extract-plugin
export default {"brandsDiv":"BrandsContent_brandsDiv__11eQY","input":"BrandsContent_input__Pe6Fx","text":"BrandsContent_text__8nuq6","mb16":"BrandsContent_mb16__-3uF5"};